// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".building_manage_footer[data-v-732420c9]{width:100%;position:fixed;left:0;bottom:0;padding:15px 0 24px;margin:0!important;z-index:50;background:var(--black)}.building_manage[data-v-732420c9]{max-width:940px;width:100%;justify-content:space-between;margin:0 auto;display:flex;align-items:center}.footerright[data-v-732420c9]{margin-left:auto;display:flex;gap:24px}.footer-btn[data-v-732420c9]{width:120px}", ""]);
// Exports
module.exports = exports;
